import { render, staticRenderFns } from "./statementManagementLeader.vue?vue&type=template&id=44daade7&scoped=true"
import script from "./statementManagementLeader.vue?vue&type=script&lang=js"
export * from "./statementManagementLeader.vue?vue&type=script&lang=js"
import style0 from "./statementManagementLeader.vue?vue&type=style&index=0&id=44daade7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44daade7",
  null
  
)

export default component.exports